const superscripts = {
  0: '⁰',
  1: '¹',
  2: '²',
  3: '³',
  4: '⁴',
  5: '⁵',
  6: '⁶',
  7: '⁷',
  8: '⁸',
  9: '⁹',
}

function toSuperscript(sup) {
  const sign = sup < 0 ? '⁻' : ''
  const absArray = Math.abs(Number(sup)).toString().split('')
  return `${sign}${absArray.map((digit) => superscripts[digit]).join('')}`
}

function formatNumber(num, format, precision = 2) {
  if (isNaN(num) || num === null || num === undefined) {
    return 'N/A'
  }

  const absNum = Math.abs(num)
  const sign = num < 0 ? '-' : ''

  if (absNum === 0) return 0
  if (format === 'e') {
    const [base, sup] = num.toExponential(precision).split('e')
    const supSign = sup < 0 ? '-' : ''
    return `${base * 1}e${supSign}${Math.abs(sup)}`
  } else if (format === 'scientific') {
    const [base, sup] = num.toExponential(precision).split('e')
    return `${base * 1}x10${toSuperscript(sup)}`
  }

  const fixedPrecision = precision + 1

  if (absNum >= 1_000_000_000_000_000) {
    return `${sign}${(absNum / 1_000_000_000_000_000).toFixed(fixedPrecision) * 1}Q`
  }
  if (absNum >= 1_000_000_000_000) {
    return `${sign}${(absNum / 1_000_000_000_000).toFixed(fixedPrecision) * 1}T`
  }
  if (absNum >= 1_000_000_000) {
    return `${sign}${(absNum / 1_000_000_000).toFixed(fixedPrecision) * 1}B`
  }
  if (absNum >= 1_000_000) {
    return `${sign}${(absNum / 1_000_000).toFixed(fixedPrecision) * 1}M`
  }
  if (absNum >= 1_000) {
    return `${sign}${(absNum / 1_000).toFixed(fixedPrecision) * 1}K`
  }

  if (absNum < 0.01 && absNum > 0) {
    const [base, sup] = num.toExponential(precision).split('e')
    if (format === 'e_small') {
      const supSign = sup < 0 ? '-' : ''
      return `${base * 1}e${supSign}${Math.abs(sup)}`
    }
    return `${base * 1}x10${toSuperscript(sup)}`
  }

  if (Number.isInteger(num)) {
    return num.toString()
  }

  return num.toPrecision(fixedPrecision)
}

export function parseNumericLabel(label) {
  if (label == null) return null
  const num = parseFloat(label)
  return /^\s*-?\d/.test(String(label)) && !isNaN(num) ? num : null
}

export function formatParamLabel(label, format) {
  if (label == null) return label
  const num = Number(label)
  return /\d/.test(String(label)) && !isNaN(num)
    ? formatNumber(num, format)
    : label
}

const MAX_TICKMARK_PRECISION = 6

export function formatNumberTickmarks(values, format) {
  for (let precision = 2; precision <= MAX_TICKMARK_PRECISION; precision++) {
    const labels = values.map((v) => formatNumber(v, format, precision))
    if (new Set(labels).size === labels.length) return labels
  }
  return values.map((v) => formatNumber(v, format, MAX_TICKMARK_PRECISION))
}

export default formatNumber
